import { ApolloClient, InMemoryCache, NormalizedCacheObject, createHttpLink } from '@apollo/client';
import { NextPageContext } from 'next';

export default function createApolloClient(
  initialState: NormalizedCacheObject,
  ctx?: NextPageContext
): ApolloClient<NormalizedCacheObject> {
  // The `ctx` (NextPageContext) will only be present on the server.
  // use it to extract auth headers (ctx.req) or similar.

  const enchancedFetch = (url: RequestInfo | URL, init?: RequestInit) =>
    fetch(url as string, {
      ...init,
      headers: {
        ...init?.headers,
        Cookie: (ctx?.req?.headers?.cookie as string) ?? '',
      },
    }).then((response) => response);

  return new ApolloClient({
    ssrMode: Boolean(ctx),
    link: createHttpLink({
      uri: ctx && process.env.API_INTERNAL_URI ? process.env.API_INTERNAL_URI : process.env.NEXT_PUBLIC_API_URI,
      credentials: 'include',
      fetch: ctx ? enchancedFetch : fetch,
      headers: {
        'apollo-require-preflight': '1',
      },
    }),
    cache: new InMemoryCache().restore(initialState),
  });
}
